module.exports = __webpack_public_path__ + "img/wechat2.8959f993.jpg";